import React from "react";

export function DataTable({ columns, rows, actions, testId }) {
  return (
    <div className="overflow-x-auto w-full scada-panel" data-testid={testId}>
      <div className="min-w-[640px]">
        <div className="grid border-b border-[#2C3238] scada-label" style={{ gridTemplateColumns: `${columns.map(c => c.w || "1fr").join(" ")} 140px` }}>
          {columns.map((c) => <div key={c.key} className="px-4 py-3">{c.label}</div>)}
          <div className="px-4 py-3 text-right">ACTIONS</div>
        </div>
        {rows.length === 0 && <div className="text-center py-10 text-[#5A6573] font-mono-metric text-sm">No records</div>}
        {rows.map((r) => (
          <div key={r.id} className="grid border-b border-[#2C3238]/60 items-center hover:bg-[#1E2226]/40" style={{ gridTemplateColumns: `${columns.map(c => c.w || "1fr").join(" ")} 140px` }}>
            {columns.map((c) => <div key={c.key} className="px-4 py-3 text-sm">{c.render ? c.render(r) : r[c.key]}</div>)}
            <div className="px-4 py-3 flex gap-1 justify-end">{actions?.(r)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Modal({ open, onClose, title, children, testId }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-6" onClick={onClose} data-testid={testId}>
      <div className="scada-panel-strong w-full max-w-lg p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-black text-xl tracking-tight">{title}</h3>
          <button onClick={onClose} className="text-[#9BA4B5] hover:text-[#E3E8EE] text-xl leading-none">×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block mb-3">
      <div className="scada-label mb-1">{label}</div>
      {children}
    </label>
  );
}

export function inputCls() {
  return "w-full border bg-[#0B0D0F] px-3 py-2 text-sm font-mono-metric";
}

export function PrimaryBtn({ children, ...rest }) {
  return <button {...rest} className="border border-[#00E5FF] text-[#00E5FF] hover:bg-[#00E5FF]/10 px-4 py-2 font-mono-metric uppercase tracking-wider text-xs">{children}</button>;
}

export function GhostBtn({ children, ...rest }) {
  return <button {...rest} className="border border-[#2C3238] text-[#9BA4B5] hover:text-[#E3E8EE] hover:border-[#E3E8EE] px-3 py-1.5 font-mono-metric uppercase tracking-wider text-[10px]">{children}</button>;
}

export function DangerBtn({ children, ...rest }) {
  return <button {...rest} className="border border-[#FF3B30] text-[#FF3B30] hover:bg-[#FF3B30]/10 px-3 py-1.5 font-mono-metric uppercase tracking-wider text-[10px]">{children}</button>;
}
